import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import {AudioPlayerProvider} from 'react-use-audio-player'

import {PlayerStatsProvider} from './context/PlayerStatsContext'

import './css/index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
    <BrowserRouter>
        <PlayerStatsProvider>
            <AudioPlayerProvider>
                <App /> 
            </AudioPlayerProvider>
        </PlayerStatsProvider>
    </BrowserRouter>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
